import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get all stores with prepaid balance
   */
  getWalletBalances() {
    return backofficeService.Api().get('api/smsWalletReports.js/walletBalances')
      .then((response) => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Get SMS credits used by store and month
   * @param {Object} params - Query parameters
   * @param {string} params.fromDate - Start date
   * @param {string} params.toDate - End date
   */
  getCreditsUsedByMonth(params) {
    return backofficeService.Api().get('api/smsWalletReports.js/creditsUsedByMonth', { params })
      .then((response) => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Get credits purchased vs used by store and month
   * @param {Object} params - Query parameters
   * @param {string} params.fromDate - Start date
   * @param {string} params.toDate - End date
   */
  getCreditsPurchasedVsUsed(params) {
    return backofficeService.Api().get('api/smsWalletReports.js/creditsPurchasedVsUsed', { params })
      .then((response) => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Get refund history from logs
   * @param {Object} params - Query parameters
   * @param {string} params.fromDate - Start date
   * @param {string} params.toDate - End date
   */
  getRefundHistory(params) {
    return backofficeService.Api().get('api/smsWalletReports.js/refundHistory', { params })
      .then((response) => response.data)
      .catch((error) => { throw error })
  },
}
